<template>
  <div class="guarantee-manage">
    <div class="page-header">
      <h2>保障管理</h2>
    </div>
    
    <!-- 标签页 -->
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="车辆保障信息" name="vehicle">
        <VehicleGuaranteeTab />
      </el-tab-pane>
      <el-tab-pane label="保障说明内容" name="content">
        <GuaranteeContentTab />
      </el-tab-pane>
      <el-tab-pane label="理赔流程" name="process">
        <ClaimsProcessTab />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VehicleGuaranteeTab from './guarantee/VehicleGuaranteeTab.vue'
import GuaranteeContentTab from './guarantee/GuaranteeContentTab.vue'
import ClaimsProcessTab from './guarantee/ClaimsProcessTab.vue'

export default {
  name: 'GuaranteeManage',
  components: {
    VehicleGuaranteeTab,
    GuaranteeContentTab,
    ClaimsProcessTab
  },
  data() {
    return {
      activeTab: 'vehicle'
    }
  }
}
</script>

<style scoped>
.guarantee-manage {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #333;
}
</style> 